/**
 * Tracks the "I just captured something" emotional peak —
 * the moment cloud-backup intent is at its strongest.
 *
 * Recorded on Camera exit (when shotCount > 0).
 * Consumed once on Sessions page mount, then cleared.
 *
 * 24h dismissal cooldown so we don't nag.
 */

const KEY_PENDING = "ssc:postCaptureNudge";
const KEY_DISMISSED_AT = "ssc:upgradeNudgeDismissedAt";

const DISMISS_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export const CaptureMoment = {
  /** Called from Camera on exit. count = photos captured in this session. */
  recordBatch(count, sessionName) {
    if (!count || count <= 0) return;
    try {
      localStorage.setItem(KEY_PENDING, JSON.stringify({
        count,
        sessionName: sessionName || "",
        at: Date.now(),
      }));
    } catch { /* storage full / disabled — silent */ }
  },

  /** Returns the pending nudge payload or null. Does NOT clear it. */
  readPending() {
    try {
      const raw = localStorage.getItem(KEY_PENDING);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      // Stale > 1h — ignore
      if (Date.now() - parsed.at > 60 * 60 * 1000) {
        localStorage.removeItem(KEY_PENDING);
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  },

  /** Clear without dismissal stamping — used after consumption. */
  clearPending() {
    localStorage.removeItem(KEY_PENDING);
  },

  /** User dismissed the nudge → suppress for 24h. */
  markDismissed() {
    localStorage.setItem(KEY_DISMISSED_AT, String(Date.now()));
    localStorage.removeItem(KEY_PENDING);
  },

  isDismissedRecently() {
    const at = Number(localStorage.getItem(KEY_DISMISSED_AT) || 0);
    return Date.now() - at < DISMISS_COOLDOWN_MS;
  },
};
